<template>
  <canvas ref="canvasRef" :style="`--size: ${size}px;--color:${color}`" class="clock-canvas"></canvas>
</template>




<script setup>
import { ref, onMounted, useTemplateRef, onUpdated, computed } from 'vue'
import dayjs from 'dayjs'
import * as echarts from 'echarts'

const canvasRef = useTemplateRef('canvasRef')
const size = ref(36)

const color = computed(() => {
  return props.isCharging ? '#39BE3E' : '#FD5938'
})

/**
 * 解析时间字符串为小时、分钟、秒
 * @param time 时间字符串
 * @returns { hour: number, minute: number, second: number }
 */
function parseTime(time) {
  const hour = dayjs(time).get('hour')
  const minute = dayjs(time).get('minute')
  const second = dayjs(time).get('second')
  return {
    hour: hour > 12 ? hour - 12 : hour,
    minute: minute,
    second: second
  }
}


/**
 * 获取时间字符串的分钟数
 * @param time 时间字符串
 * @returns { number }
 */
function getMinutes(time) {
  const obj = parseTime(time)
  return obj.hour * 60 + obj.minute
}

const props = defineProps({
  startTime: {
    type: String,
    required: true
  },
  endTime: {
    type: String,
    required: true
  },
  isCharging: {
    type: Boolean,
    default: false
  }
})

function drawClock() {
  const canvasSize = size.value
  const canvas = canvasRef.value
  const dpr = window.devicePixelRatio || 1
  canvas.style.width = `${canvasSize}px`
  canvas.style.height = `${canvasSize}px`
  canvas.width = Math.round(canvasSize * dpr)
  canvas.height = Math.round(canvasSize * dpr)
  const context = canvas.getContext('2d')
  context.setTransform(dpr, 0, 0, dpr, 0, 0)
  context.clearRect(0, 0, canvasSize, canvasSize)
  const centerX = canvasSize / 2
  const centerY = canvasSize / 2
  const radius = canvasSize / 2

  // 最外层圆
  const linegradient = context.createLinearGradient(0, 0, canvasSize, canvasSize)
  linegradient.addColorStop(0, echarts.color.modifyAlpha(color.value, 0.1))
  linegradient.addColorStop(1, echarts.color.modifyAlpha(color.value, 0.5))

  context.lineWidth = 2
  context.strokeStyle = color.value
  context.fillStyle = linegradient//echarts.color.modifyAlpha(props.color, 0.1)
  context.beginPath()
  context.arc(centerX, centerY, radius - 1, 0, 2 * Math.PI)
  context.stroke()
  // context.fill()

  // 上右下左4个刻度
  const tickLength = 4
  const positions = [
    [centerX, 0, centerX, tickLength],//上
    [canvasSize, centerY, canvasSize - tickLength, centerY],//右
    [centerX, canvasSize, centerX, canvasSize - tickLength],//下
    [0, centerY, tickLength, centerY], //左
  ]
  context.save()
  context.lineWidth = 1
  context.strokeStyle = color.value
  context.lineCap = 'round'
  positions.forEach(position => {
    const [x, y, x2, y2] = position
    context.beginPath()
    context.moveTo(x, y)
    context.lineTo(x2, y2)
    context.stroke()
  })
  context.restore()

  // 绘制持续区域
  const startAngle = getMinutes(props.startTime) / 720 * Math.PI * 2 - Math.PI / 2
  const endAngle = getMinutes(props.endTime) / 720 * Math.PI * 2 - Math.PI / 2
  let gradient = context.createLinearGradient(centerX, centerY, centerX + Math.cos(startAngle + (endAngle - startAngle) / 2) * (radius), centerY + Math.sin(startAngle + (endAngle - startAngle) / 2) * (radius))
  gradient.addColorStop(0, echarts.color.modifyAlpha(color.value, 0.5))
  gradient.addColorStop(1, echarts.color.modifyAlpha(color.value, 0.1))

  context.save()
  context.fillStyle = gradient//echarts.color.modifyAlpha(color.value, 0.5)
  context.strokeStyle = color.value
  context.beginPath()
  context.moveTo(centerX, centerY)
  context.arc(centerX, centerY, radius - 1, startAngle, endAngle)
  context.fill()
  context.closePath()
  // context.stroke()
  context.restore()

  // 绘制指针:开始为虚线、结束为实现
  context.save()
  context.lineWidth = 2
  context.strokeStyle = color.value
  context.lineCap = 'round'
  context.beginPath()
  context.moveTo(centerX, centerY)
  context.lineTo(centerX + Math.cos(startAngle) * (radius - 5), centerY + Math.sin(startAngle) * (radius - 5))
  context.stroke()
  context.restore()

  context.save()
  context.lineWidth = 2
  context.strokeStyle = color.value
  context.lineCap = 'round'
  context.beginPath()
  context.moveTo(centerX, centerY)
  context.lineTo(centerX + Math.cos(endAngle) * (radius - 5), centerY + Math.sin(endAngle) * (radius - 5))
  context.stroke()
  context.restore()




}


onMounted(() => {
  drawClock()
})

onUpdated(() => {
  drawClock()
})



</script>




<style scoped lang="scss">
.clock-canvas {
  width: var(--size);
  height: var(--size);
}
</style>
